import {
  FETCH_ACCOUNT_REPORT,
  FETCH_ACCOUNT_REPORT_START,
  FETCH_ACCOUNT_REPORT_END,
  FETCH_ACCOUNT_REPORT_ERROR,
  REMOVE_ACCOUNT_REPORT,
} from '../actions/types';

const initialState = {
  isLoading: null,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case FETCH_ACCOUNT_REPORT:
      return { ...state, report: action.payload };
    case FETCH_ACCOUNT_REPORT_START:
      return { ...state, isLoading: true };
    case FETCH_ACCOUNT_REPORT_END:
      return { ...state, isLoading: false };
    case FETCH_ACCOUNT_REPORT_ERROR:
      return { ...initialState, error: action.payload };
    case REMOVE_ACCOUNT_REPORT:
      return { ...initialState };
    default:
      return state;
  }
}
